import React from 'react';
import parse from 'html-react-parser';
import { mergeClassNames } from '@frontend/jetlend-web-ui/src/utils/classNameUtils';
import styles from './WpPostContent.module.scss';
import { formatTextWithNumbers } from '@app/utils/formatTextWithNumbers';
import { options } from '@app/components/WpPostContent/wpPostContent.logic';

interface IProps {
    /**
     * Содержимое в формате html
     */
    content: string;
    /**
     * Класс для контента
     */
    contentClassName?: string;
}

/**
 * Компонент для отображения содержимого поста WordPress
 */
export default function WpPostContent({
    content,
    contentClassName,
}: IProps) {

    const contentClassNames = mergeClassNames([
        styles['content'],
        contentClassName,
    ]);

    return (
        <div className={contentClassNames}>
            {parse(formatTextWithNumbers(content), options)}
        </div>
    );
}
